import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroImage() {
  return <section className="w-full relative h-[60vh] min-h-[400px] max-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-65">
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/gEeQjnyxzgf74y3KG3hGAQ/banner_Pagina_de_Venta_fuego_nadie_ve.png")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-66" />
      <div className="absolute inset-0 bg-black/40 z-10 mix-blend-multiply" data-id="element-67" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent z-10" data-id="element-68" />

      <div className="relative z-20 text-center px-4" data-id="element-69">
        <FadeIn data-id="element-70">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white tracking-wider drop-shadow-lg" style={{
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }} data-id="element-71">
            THE KITCHEN PHARMACY
          </h2>
        </FadeIn>
      </div>
    </section>;
}